import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useCustomHook from "./useCustomHook ";
import axiosInstance from "../../../utils/axiosInstance";

const Completeorders = () => {
  const { orderData, products, userDetails } = useCustomHook("neworder");


  
  const goBack = () => {
    window.history.back();
};
  
  return (

    <div className="mt-16">
    <div className="mt-8 mx-auto max-w-screen-lg overflow-x-auto hidden md:block">

    <h2 className="text-3xl font-bold mb-6">Order Details</h2>
    <div className="overflow-x-auto">
    <table className="w-full bg-white border rounded-lg overflow-hidden">
        <thead className="bg-gray-800 text-white">
          <tr>
            <th className="py-2 px-4 text-left">Order ID</th>
            <th className="py-2 px-4 text-left">User ID</th>
            <th className="py-2 px-4 text-left">User Details</th>
            <th className="py-2 px-4 text-left">Product Details</th>
            <th className="py-2 px-4 text-left">Status</th>
            <th className="py-2 px-4 text-left">Order Date</th>
            <th className="py-2 px-4 text-left">Total Price</th>
          </tr>
        </thead>
        <tbody>
          {orderData.map((order, index) => (
            <tr key={order._id} className="p-1">
              <td className="py-2 px-4">{order._id}</td>
              <td className="py-2 px-4">{order.user}</td>
              <td className="py-2 px-4">
                {userDetails[order.user] ? (
                  <>
                    <p className="mb-1 text-sm">
                      <strong>Name:</strong> {userDetails[order.user].username}
                    </p>
                    <p className="mb-1 text-sm">
                      <strong>Phone:</strong> {userDetails[order.user].phone}
                    </p>
                    <p className="text-sm">
                      <strong>Address:</strong> {userDetails[order.user].address}
                    </p>
                  </>
                ) : (
                  <p className="text-sm">No user details available</p>
                )}
              </td>
              <td className="py-2 px-4">
                {products[index] &&
                  products[index].map((product) => (
                    <div key={product._id} className="mb-2">
                      <p className="mb-1 text-sm">
                        <strong>Name:</strong> {product.name}
                      </p>
                      <img
                        src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                        className="w-16 h-16 md:h-10 object-cover mb-2 rounded-r-2xl"
                        alt="Product"
                      />
                      <p className="mb-1 text-sm">
                        <strong>Price:</strong> {product.price}
                      </p>
                      <p className="text-sm">
                        <strong>Description:</strong> {product.description}
                      </p>
                    </div>
                  ))}
              </td>
              <td className="py-2 px-4">{order.status}</td>
              <td className="py-2 px-4">
                {new Date(order.order_date).toLocaleString()}
              </td>
              <td className="py-2 px-4">{order.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>

  <div className="flex justify-end mr-14 md:hidden ">
  <div className="">
  <button  className="bg-amber-500 hover:bg-amber-400 text-white font-bold py-1 px-2 border-b-4 border-amber-700 hover:border-blue-500 rounded" onClick={goBack}>
            Go Back
        </button>   
           
        </div>
  <div className="mt-10 grid grid-cols-1 gap-3 p-2 ">
  {orderData.map((order, index) => (
    <div key={order._id} className="bg-white border rounded-lg w-52 overflow-hidden p-4 shadow-md">
      <Link to={`/admin/single/${order._id}`}>
      <div className="text-sm">
        {userDetails[order.user] ? (
          <>
            <div className="font-bold mb-3">Order Details</div>
            <p className="mb-1">
              <strong>Order:</strong> {userDetails[order.user].username}
            </p>
            <p className="mb-1">
              <strong>Phone:</strong> {userDetails[order.user].phone}
            </p>
            <p>
              <strong>Address:</strong> {userDetails[order.user].address}
            </p>
          </>
        ) : (
          <p className="mb-3">No user details available</p>
        )}
      </div>
      {/* <div className="text-sm mt-4">
        <div className="font-bold mb-3">Product Details</div>
        {products[index] &&
          products[index].map((product) => (
            <div key={product._id} className="mb-4">
              <p className="mb-1">
                <strong>Name:</strong> {product.name}
              </p>
              <img
                src={`http://localhost:3000/${product.image}`}
                className="w-16 h-16 md:h-10 object-cover mb-2 rounded-r-2xl"
                alt="Product"
              />
              <p className="mb-1">
                <strong>Price:</strong> {product.price}
              </p>
              <p>
                <strong>Description:</strong> {product.description}
              </p>
              <hr className="my-2" />
            </div>
          ))}
      </div> */}
      <div className="text-sm mt-4">
        <p className="mb-1">
          <strong>Status:</strong> {order.status}
        </p>
        <p className="mb-1">
          <strong>Order Date:</strong> {new Date(order.order_date).toLocaleString()}
        </p>
        <p>
          <strong>Total Price:</strong> <span className="text-red-500">Rs:{order.price}</span>
        </p>
      </div>
      </Link>
    </div>
  ))}
</div>

  </div>



    
    </div>

  );
};

export default Completeorders;
